import { render } from "./AppointmentListComponent.vue?vue&type=template&id=fed09ba2"
import script from "./AppointmentListComponent.vue?vue&type=script&lang=js"
export * from "./AppointmentListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__